import { useEffect, useState } from 'react';

type Props = {
  initialValue: string; // formato 'mm:ss'
  onConfirm: (formattedTime: string) => void;
};

export function DurationInput({ initialValue, onConfirm }: Props) {
  const [inputValue, setInputValue] = useState(initialValue);

  useEffect(() => {
    setInputValue(initialValue);
  }, [initialValue]);

  const validateAndFormat = (value: string): string | null => {
    const regex = /^(\d{1,3}):([0-5]?\d)$/;
    const match = value.match(regex);
    if (!match) return null;

    const minutes = parseInt(match[1], 10);
    const seconds = parseInt(match[2], 10);

    if (seconds > 59) return null;

    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  const confirmInput = () => {
    const formatted = validateAndFormat(inputValue);
    if (formatted) {
      setInputValue(formatted);
      onConfirm(formatted);
    } else {
      setInputValue(initialValue);
    }
  };

  const handleBlur = () => {
    confirmInput();
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      confirmInput();
    }
  };

  return (
    <input
      type="text"
      value={inputValue}
      onChange={e => setInputValue(e.target.value)}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      placeholder="mm:ss"
      inputMode="numeric"
      className="h-[25px] w-[60px] text-basic"
    />
  );
}
